import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { OrganisationSectionsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createOrganisationSection = (data): any => action(types.CREATE_ORGANISATION_SECTION_REQUESTED, data);

export const updateOrganisationSection = (data): any => action(types.UPDATE_ORGANISATION_SECTION_REQUESTED, data);

export const deleteOrganisationSection = (organisationSectionId): any => action(types.UPDATE_ORGANISATION_SECTION_REQUESTED, organisationSectionId);

export const getOrganisationSection = (organisationSectionId): any => action(types.GET_ORGANISATION_SECTION_REQUESTED, organisationSectionId);

export const getAllOrganisationSections = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ORGANISATION_SECTIONS_REQUESTED, {
  pagination,
  compile,
});

export const selectOrganisationSection = (organisationSectionId): any => action(types.SELECT_ORGANISATION_SECTION_REQUESTED, {
  currentOrganisationSectionId: organisationSectionId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createOrganisationSectionPending: (payload): any => action(types.CREATE_ORGANISATION_SECTION_PENDING, payload),
  createOrganisationSectionSuccess: (response): any => {
    const currentOrganisationSection = response.entities.organisationSections[response.result];
    // history.push(`/payment/${currentOrganisationSection.paymentCollection.id}/review`);
    return action(types.CREATE_ORGANISATION_SECTION_SUCCESS, {
      organisationSectionsById: response.entities.organisationSections,
      currentOrganisationSectionId: response.result,
    });
  },
  updateOrganisationSectionPending: (payload): any => action(types.UPDATE_ORGANISATION_SECTION_PENDING, payload),
  updateOrganisationSectionSuccess: (response): any => action(types.UPDATE_ORGANISATION_SECTION_SUCCESS, {
    organisationSectionsById: response.entities.organisationSections,
    currentOrganisationSectionId: response.result,
  }),
  updateOrganisationSectionFailed: (error): any => action(types.UPDATE_ORGANISATION_SECTION_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationSectionPending: (): any => action(types.UPDATE_ORGANISATION_SECTION_PENDING, {}),
  deleteOrganisationSectionSuccess: (response, userId): any => {
    localStorage.set(userId, { currentOrganisationSectionId: null });
    history.push('/organisationSections');

    return action(types.DELETE_ORGANISATION_SECTION_SUCCESS, {
      currentOrganisationSectionId: response,
    });
  },
  getOrganisationSectionPending: (): any => action(types.GET_ORGANISATION_SECTION_PENDING, {}),
  getOrganisationSectionSuccess: (response): any => action(types.GET_ORGANISATION_SECTION_SUCCESS, {
    organisationSectionsById: response.entities.organisationSections,
    currentOrganisationSectionId: response.result,
  }),
  getOrganisationSectionFailed: (error): any => action(types.GET_ORGANISATION_SECTION_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationSectionFailed: (error): any => action(types.UPDATE_ORGANISATION_SECTION_FAIL, {
    backendErrors: error,
  }),
  getAllOrganisationSectionsPending: (pagination): any => action(types.GET_ALL_ORGANISATION_SECTIONS_PENDING, { pagination }),
  getAllOrganisationSectionsSuccess: (response, meta): any => action(types.GET_ALL_ORGANISATION_SECTIONS_SUCCESS, {
    organisationSectionsById: response.entities.sections,
    organisationSectionIds: response.result,
    meta,
  }),
  getAllOrganisationSectionsFailed: (error): any => action(types.GET_ALL_ORGANISATION_SECTIONS_FAIL, {
    backendErrors: error,
  }),
  createOrganisationSectionFailed: (error): any => action(types.CREATE_ORGANISATION_SECTION_FAIL, {
    backendErrors: error,
  }),
};

export default null;
